<template>
  <div class="shipped-order-address-component">
    <div class="address-card">
      <img src="../../../assets/img/personalCenter/address.png" alt="地址" />
      <div class="address-info">
        <span class="person-info">
          <span>{{ frontData.consignee }}</span>
          <span>{{ frontData.phone }}</span>
        </span>
        <span class="address-text">{{ frontData.addressDetail }}</span>
      </div>
      <img
        src="../../../assets/img/personalImg/edit_icon.png"
        alt="编辑"
        class="edit-icon"
        @click="editAddress"
        v-if="!delivered"
      />
    </div>
    <div class="express-card" v-if="isExpress">
      <img src="../../../assets/img/personalCenter/express.png" alt="物流" />
      <div class="address-info">
        <span class="person-info">
          <span>{{ expressList[frontData.expressType] }}</span>
          <span></span>
        </span>
        <span class="address-text">
          <span>{{ frontData.expressNo }}</span>
          <img
            src="../../../assets/img/personalCenter/copy.png"
            alt="复制"
            @click="copy(frontData.expressNo)"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { copyTool } from '@/utils/tools';

export default {
  props: {
    frontData: {
      type: Object,
      default: () => {},
    },
    isExpress: {
      // 是否显示物流
      type: Boolean,
      default: false,
    },
    delivered: {
      // 是否是已发货
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expressList: {
        1: '中通快递',
        2: '申通快递',
        3: '韵达快递',
        4: '圆通快递',
        5: '邮政快递',
        6: '顺丰快递',
        7: '百世快递',
        8: '京东快递',
      },
    };
  },
  methods: {
    copy(val) {
      copyTool(val)
        .then(() => {
          this.$toast('复制成功');
        })
        .catch(() => {
          this.$toast('复制失败');
        });
    },
    editAddress() {
      if (!this.$route.query.orderNo) {
        this.$toast('无法获取订单信息！');
        return;
      }
      const { orderNo } = this.$route.query;
      const { orderAddressId } = this.frontData;
      this.$router.push({
        path: '/personalCenter/address',
        query: { orderAddressId, orderNo, changeAddress: '1' },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.shipped-order-address-component {
  background: white;
  border-radius: 14px;

  .address-card,
  .express-card {
    display: flex;
    align-items: center;

    img {
      width: 54px;
      height: 54px;
      margin: 0 29px;
    }

    .edit-icon {
      align-self: flex-start;
      width: 43px;
      height: 43px;
      margin-top: 34px;
    }

    .address-info {
      flex: 1;

      .person-info {
        display: flex;
        padding-top: 36px;

        span {
          display: block;
          color: #333;
          font-weight: bold;
          font-size: 25px;
          line-height: 36px;

          &:last-child {
            margin-left: 25px;
          }
        }
      }
      .address-text {
        display: flex;
        align-items: center;
        margin-top: 18px;
        margin-right: 36px;
        margin-bottom: 36px;
        color: #787878;
        font-size: 25px;
        line-height: 36px;
        word-break: break-all;

        span {
          margin-top: -4px;
        }

        img {
          width: 43px;
          height: 43px;
          margin: -4px 0 0 7px;
        }
      }
    }
  }

  .express-card {
    position: relative;
    &::before {
      position: absolute;
      top: -1px;
      left: 0;
      width: calc(100% - 58px);
      height: 2px;
      margin: 0 29px;
      background: #f5f5f5;
      content: '';
    }
  }
}
</style>
